import { PlusIcon } from '@phosphor-icons/react';

import { Button } from '@/ui/button/Button';

interface LocationBarProps {
  /** Breadcrumb / title content on the left. */
  children: React.ReactNode;
  /** Show the primary "New issue" action. */
  onNewIssue?: () => void;
  /** Custom primary action rendered on the right (e.g. "New run"). */
  action?: React.ReactNode;
}

/** Top bar of the main card (48px): breadcrumb left, primary action right. */
export function LocationBar({ children, onNewIssue, action }: LocationBarProps) {
  return (
    <div className="flex items-center gap-3 h-12 px-4 border-b border-line-subtle shrink-0">
      <div className="flex items-center gap-2 min-w-0 flex-1">{children}</div>

      {onNewIssue && (
        <Button variant="primary" size={8} onClick={onNewIssue} iconLeft={<PlusIcon size={14} weight="bold" />}>
          New issue
        </Button>
      )}

      {action}
    </div>
  );
}
